'use client';

import { getRequiredPasswordLength } from '@pioz/mlm-common';
import clsx from 'clsx';
import { BadgeCheck, BadgeX } from 'lucide-react';

export interface PasswordCheckT {
  passwordLength: string;
  passwordLowercase: string;
  passwordUppercase: string;
  passwordNumber: string;
  passwordNoSpace: string;
  passwordEqual: string;
  passwordSpecialChar: string;
}

export const PasswordCheck = ({
  password,
  passwordConfirm,
  className = 'flex w-fit flex-col',
  config,
  t,
}: {
  password: string;
  passwordConfirm: string;
  className?: string;
  config?: { checkSpecialChars?: boolean };
  t: PasswordCheckT;
}) => {
  return (
    <div className={clsx(className, '[&>div]:flex [&>div]:gap-1')}>
      <div>
        <IconFactory error={password.length < getRequiredPasswordLength()} />
        <span>{t.passwordLength.replace('{length}', getRequiredPasswordLength() + '')}</span>
      </div>
      <div>
        <IconFactory error={!/[a-z]/.test(password)} />
        <span>{t.passwordLowercase}</span>
      </div>
      <div>
        <IconFactory error={!/[A-Z]/.test(password)} />
        <span>{t.passwordUppercase}</span>
      </div>
      <div>
        <IconFactory error={/^\D*$/.test(password)} />
        <span>{t.passwordNumber}</span>
      </div>
      <div>
        <IconFactory error={/\s/g.test(password)} />
        <span>{t.passwordNoSpace}</span>
      </div>
      {config?.checkSpecialChars && (
        <div>
          <IconFactory error={!/[!@#$%^&*()_+\-=]/.test(password)} />
          <span>{t.passwordSpecialChar}</span>
        </div>
      )}
      <div>
        <IconFactory error={password.length === 0 || password !== passwordConfirm} />
        <span>{t.passwordEqual}</span>
      </div>
    </div>
  );
};

function IconFactory({ error }: { error: boolean }) {
  return error ? (
    <BadgeX className="text-error shrink-0" />
  ) : (
    <BadgeCheck className="text-success shrink-0" />
  );
}
